import React from 'react';
import { connect } from 'react-redux';
import SelfDefinedUserId from './SelfDefinedUserId';
class SelfDefinedUserIdDialog extends React.Component {
    constructor(props) {
        super(props)
      }
    render() { 
        return (
            <React.Fragment>
                <div style={{ width: '500px', padding: '5px 15px' }}>
                    <SelfDefinedUserId/>
                </div>
            </React.Fragment>
        );
    }
}
 
export default connect(
    state => ({
      language: state.app.language
    })
) (SelfDefinedUserIdDialog)